/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online percentage calculators — work out percentages, increases, decreases, differences, tips and discounts in seconds.`)
};

const es_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de porcentaje gratuitas en línea — calcula porcentajes, aumentos, disminuciones, diferencias, propinas y descuentos en segundos.`)
};

const de_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Online-Prozentrechner — berechne Prozentsätze, Anstiege, Rückgänge, Unterschiede, Trinkgeld und Rabatte in Sekunden.`)
};

const nl_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online percentagecalculators — bereken percentages, stijgingen, dalingen, verschillen, fooien en kortingen in enkele seconden.`)
};

const fr_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateurs de pourcentage gratuits en ligne — calculez pourcentages, augmentations, diminutions, différences, pourboires et réductions en quelques secondes.`)
};

const it_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori di percentuali online gratuiti: calcola percentuali, aumenti, cali, differenze, mance e sconti in pochi secondi.`)
};

const pt_br2_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de porcentagem gratuitas e online — calcule porcentagens, aumentos, diminuições, diferenças, gorjetas e descontos em segundos.`)
};

const pt_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de percentagens gratuitas e online — calcule percentagens, aumentos, diminuições, diferenças, gorjetas e descontos em segundos.`)
};

const ja_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインパーセント計算機 — パーセント、増加、減少、差、チップ、割引を数秒で計算。`)
};

const zh_pct_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线百分比计算器 — 快速计算百分比、增长、减少、差异、小费和折扣。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tool_description", locale)
	if (locale === "en") return en_pct_tool_description(inputs)
	if (locale === "es") return es_pct_tool_description(inputs)
	if (locale === "de") return de_pct_tool_description(inputs)
	if (locale === "nl") return nl_pct_tool_description(inputs)
	if (locale === "fr") return fr_pct_tool_description(inputs)
	if (locale === "it") return it_pct_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tool_description(inputs)
	if (locale === "pt") return pt_pct_tool_description(inputs)
	if (locale === "ja") return ja_pct_tool_description(inputs)
	return zh_pct_tool_description(inputs)
};